// TO BE REPLACED with blueprint breadcrumb when we get the react package in

import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';

export interface BreadcrumbLink {
  icon?: FontAwesomeIconProps['icon'];
  label: string;
  href: string;
}

interface Props {
  links: BreadcrumbLink[];
}

export default function Breadcrumb({ links }: Props) {
  return (
    <div>
      {links.map((link, index) => (
        <React.Fragment key={link.href}>
          <a href={link.href}>
            {link.icon && <FontAwesomeIcon className="me-1" icon={link.icon} />}
            {link.label}
          </a>
          {index < links.length - 1 && ' / '}
        </React.Fragment>
      ))}
    </div>
  );
}
